import { OkResponseMessage } from "../types/backendDTOs";
import {
  ArtistUpgradeRequest,
  MultipleUserDTO,
  SingleUserDTO,
  UpdateUserDTO,
} from "../types/userDTOs";
import {
  API_URLS,
  UploadFile,
  appendFile,
  config,
  create,
  fetch,
  getApiClient,
  remove,
  update,
} from "./client";

export const fetchMyProfileCall = () =>
  fetch<SingleUserDTO>(`${API_URLS().USERS}/my-profile`, config());

export const uploadProfilePhotoCall = (image: UploadFile) => {
  const formData = new FormData();
  appendFile(formData, "image", image);
  return getApiClient().post<SingleUserDTO>(
    `${API_URLS().USERS}/my-profile/photo`,
    formData
  );
};

export const updateMyProfileCall = (updateUser: UpdateUserDTO) =>
  update<SingleUserDTO>(`${API_URLS().USERS}/my-profile`, updateUser, config());

export const deleteMyProfileCall = () =>
  remove<SingleUserDTO>(`${API_URLS().USERS}/my-profile`, config());

export const requestArtistUpgradeCall = (data: ArtistUpgradeRequest) =>
  getApiClient().post<SingleUserDTO>(
    `${API_URLS().USERS}/my-profile/artist-request`,
    data
  );

export const followOrunFollowUserCall = (id: string, action: string) =>
  create<OkResponseMessage>(
    `${API_URLS().USERS}/${id}/follow-unfollow`,
    undefined,
    config({ action: action })
  );

export const fetchSingleUser = (id: string) =>
  fetch<SingleUserDTO>(`${API_URLS().USERS}/${id}`, config());

export const fetchUserFollowersOrFollows = (
  id: number,
  type: string,
  page: number,
  count: number
) =>
  fetch<MultipleUserDTO[]>(
    `${API_URLS().USERS}/${id}/followers-follows`,
    config({ type: type, page: page, count: count })
  );

export const fetchSearchForUsers = (
  radius?: number,
  lat?: number,
  lng?: number,
  zip?: string
) =>
  fetch<SingleUserDTO[]>(
    `${API_URLS().USERS}/search`,
    config({ zip: zip, radius: radius, lat: lat, lng: lng })
  );
